import { render, staticRenderFns } from "./DashboardSuc.vue?vue&type=template&id=3e8795ae&scoped=true&"
import script from "./DashboardSuc.vue?vue&type=script&lang=js&"
export * from "./DashboardSuc.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSuc.vue?vue&type=style&index=0&id=3e8795ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8795ae",
  null
  
)

export default component.exports